import React from "react";
import "./redeem-item.css";

/** Placeholder row shown while redeem requests are loading. Mirrors RedeemItem's
 * layout with shimmer bars, matching CardRowSkeleton's treatment. */
function RedeemItemSkeleton() {
  return (
    <div className="rdm-item rdm-item--skeleton" aria-hidden="true">
      <div className="rdm-item__info">
        <span className="rdm-skeleton-bar rdm-skeleton-bar--id" />
        <span className="rdm-skeleton-bar rdm-skeleton-bar--date" />
      </div>
      <span className="rdm-skeleton-bar rdm-skeleton-bar--amount" />
      <div className="rdm-item__right">
        <div className="rdm-item__actions">
          <span className="rdm-skeleton-bar rdm-skeleton-bar--btn" />
          <span className="rdm-skeleton-bar rdm-skeleton-bar--btn" />
        </div>
      </div>
    </div>
  );
}

export default RedeemItemSkeleton;
